/* eslint-disable import/no-cycle */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './styles.css';

import { useTour } from '@reactour/tour';
import { Sidebar, Header } from '@components';
import { fakeAuthProvider } from '@services/auth';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  alterarPlanoOuUsuarioRequest,
  deslogaUsuarioRequest,
} from '../../store/modules/user/actions';
import {
  verificaTourBoasVindasRequest,
  insereRegistroBoasVindasRequest,
} from '../../store/modules/boasVindas/actions';
import { LOGIN } from '../../common/utils/paths';
import { APIAutenticacao } from '../../common/services/autenticacao';
import { PendenciaModal } from '../Pendencia';

const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  const matriculaLS = localStorage.getItem('Matricula');
  const [user, setUser] = useState(matriculaLS);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const signin = useCallback((newUser, callback) => {
    return fakeAuthProvider.signin(() => {
      setUser(newUser);
      if (typeof callback === 'function') {
        callback();
      }
    });
  }, []);

  const signout = useCallback(() => {
    return fakeAuthProvider.signout(() => {
      localStorage.removeItem('Token');
      localStorage.removeItem('Plano');
      localStorage.removeItem('Id');
      localStorage.removeItem('Matricula');
      localStorage.removeItem('auth');
      localStorage.removeItem('nivelsessao');

      setUser(null);

      dispatch(deslogaUsuarioRequest());

      navigate(LOGIN);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const value = useMemo(
    () => ({
      user,
      signin,
      signout,
    }),
    [user, signin, signout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return React.useContext(AuthContext);
};

export const RequireAuth = ({ children, modalPendencias = true }) => {
  // const location = useLocation();
  const auth = useAuth();

  APIAutenticacao.validaSessao(
    localStorage.getItem('Matricula') || '',
    localStorage.getItem('Token') || ''
    // location.pathname
  );

  if (!localStorage.getItem('Id') && !auth.user) {
    auth.signout();

    return <Navigate to={LOGIN} />;
  }

  return (
    <>
      {children}
      {modalPendencias && <PendenciaModal />}
    </>
  );
};

export const Shell = (props) => {
  const { children } = props;
  const auth = useAuth();
  const location = useLocation();
  const dispatch = useDispatch();

  const users = useSelector((state) => state.user);
  const tourBoasVindas = useSelector((state) => state.tourBoasVindas);
  const pendencias = useSelector((state) => state.user.pendencias);
  const { setIsOpen, currentStep, setCurrentStep } = useTour();

  const mantemDadosStore = useCallback(() => {
    dispatch(
      alterarPlanoOuUsuarioRequest({
        id: localStorage.getItem('Id'),
        matricula: localStorage.getItem('Matricula'),
        token: localStorage.getItem('Token'),
        plano: localStorage.getItem('Plano'),
      })
    );
  }, [dispatch]);

  useEffect(() => {
    const handleLogout = () => {
      auth.signout();

      toast.error('Sessão expirada, faça login novamente');
    };

    window.addEventListener('logout', handleLogout, { once: true });
  }, [auth]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const atualizaTour = useCallback(() => {
    if (users.matricula >= '0' && tourBoasVindas.Exibir) {
      const params = {
        matricula: users.matricula,
        etapa: currentStep + 1,
      };
      dispatch(insereRegistroBoasVindasRequest(params));
    }
  }, [dispatch, users.matricula, currentStep, tourBoasVindas.Exibir]);

  const verificaStatusTour = useCallback(() => {
    if (users.matricula >= '0' && localStorage.getItem('Matricula') !== null) {
      dispatch(verificaTourBoasVindasRequest(users.matricula));
    }
  }, [users.matricula, dispatch]);

  useEffect(() => {
    const hasPendencia = Object.values(pendencias).some(
      (pendencia) => pendencia === 1
    );

    setIsOpen(tourBoasVindas.Exibir && users.matricula >= '0' && !hasPendencia);
  }, [
    tourBoasVindas.Exibir,
    tourBoasVindas.EtapaAtual,
    setIsOpen,
    setCurrentStep,
    users.matricula,
    pendencias,
  ]);

  useEffect(() => {
    verificaStatusTour();
  }, [verificaStatusTour]);

  useEffect(() => {
    atualizaTour();
  }, [atualizaTour]);

  useEffect(() => {
    if (!!localStorage.getItem('Id') && users.id === '') {
      mantemDadosStore(localStorage.getItem('Id'));
    }
  }, [mantemDadosStore, users.id]);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="container shell">
        <Header />
        {children}
      </div>
    </div>
  );
};
